import { NewsCloseApi } from "../../Api/NewsCloseApi";

// service to close news
const closeNewsService = (
    accessToken: string,
    newsId: number,
    onSuccess?: () => void,
    onError?: (error: any) => void
) => {
    NewsCloseApi(accessToken, newsId)
        .then((res) => {
            if (res.status === 200) {
                onSuccess?.();
            }
        })
        .catch((err) => {
            console.log('err: ', err);
            onError?.(err);
        });
};

export { closeNewsService };
